const Office = window.Office;

export default Office
export {
    Office
}
